import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import actions from '../../redux/actions';
import './CollegeMetaInfoList.css';

import categoryImage from '../../public/icons/category.jpg';

const UniBlogList = (props) => {
    const { wpUniversityPosts, id } = props;
    const [universityPosts, setuniversityPosts] = useState(null);

    const getUniversityPosts = async (id) => {
        try {
            console.log('Fetching university posts...');
            const universityPostsResp = await wpUniversityPosts(id);
            if (Array.isArray(universityPostsResp)) {
                console.log('Received data:', universityPostsResp);
                setuniversityPosts(universityPostsResp);
            } else if (universityPostsResp?.data) {
                console.log('Received data:', universityPostsResp.data);
                setuniversityPosts(universityPostsResp.data);
            } else {
                console.warn('No data found in response');
                setuniversityPosts(null);
            }
        } catch (error) {
            console.error('Error fetching university posts:', error);
            setuniversityPosts(null);
        }
    };

    useEffect(() => {
        if (id != null)
            getUniversityPosts(id)
    }, [id])
    return (
        <>
     
            {universityPosts && universityPosts?.length > 0 ? (
                <div className="">
                    {universityPosts.map((post, index) => (

                        <a href={post.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                            {/* <div key={index} className="news-item2 news-item"> */}
                            <div key={index} className="faculty-card bg-white">

                                <img
                                    style={{ width: '100px', height: '100px' , borderRadius: '50%'}}
                                    src={categoryImage}
                                    alt={post.title.rendered}
                                />
                                <div className="">
                                    <h3 className="news-title">{post.title.rendered}</h3>

                                    <p className="news-description">{post.description}</p>
                                </div>
                            </div>
                        </a>
                    ))}

                </div>

            ) : (
                <p style={{ textAlign: 'center', color: '#6B7280',marginLeft:'45%' }}>No blog posts available.</p>
            )}</>
    );
}


const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => {
    const { getCollegeDetails, universityCourseEnrollment, wpUniversityPosts } = actions;
    return {
        getCollegeDetails: (center_id) => dispatch(getCollegeDetails(center_id)),
        universityCourseEnrollment: (user_id, program_id) => dispatch(universityCourseEnrollment(user_id, program_id)),
        wpUniversityPosts: (category_id) => dispatch(wpUniversityPosts(category_id)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UniBlogList);